import { render } from "./RoleItem.vue?vue&type=template&id=305f132d&scoped=true"
import script from "./RoleItem.vue?vue&type=script&lang=js"
export * from "./RoleItem.vue?vue&type=script&lang=js"

import "./RoleItem.vue?vue&type=style&index=0&id=305f132d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-305f132d"]])

export default __exports__